/**
 * URL 辅助函数
 * 用于处理 API 返回的相对路径，转换为完整的 URL
 */
import { resolveApiOrigin } from './apiBaseUrl'

/**
 * 获取可被浏览器访问的 API 源地址。
 * 同源部署时直接返回当前站点 origin，避免在生产环境硬编码 :8000。
 */
export const getApiBaseUrl = (): string => {
    const configuredOrigin = resolveApiOrigin()
    if (configuredOrigin) {
        return configuredOrigin
    }

    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin
    }

    return ''
}

/**
 * 将相对路径转换为完整的图片 URL
 * @param path 相对路径，例如 "/api/static/annotated/image.jpg"
 * @returns 完整的 URL，例如 "https://example.com/api/static/annotated/image.jpg"
 */
export const getImageUrl = (
    path: string | null | undefined
): string | undefined => {
    if (!path) {
        return undefined
    }

    // 如果已经是完整的 URL（以 http:// 或 https:// 开头），直接返回
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path
    }

    // 如果是 base64 图片，直接返回
    if (path.startsWith('data:image')) {
        return path
    }

    const baseUrl = getApiBaseUrl()

    // 确保路径以 / 开头
    const normalizedPath = path.startsWith('/') ? path : `/${path}`

    // 拼接完整 URL
    return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath
}
